import { FC, useEffect } from "react";
import { observer } from "mobx-react";
import {
  ArticleSelectorQuestion,
  DateQuestion,
  NumberQuestion,
  YesNoQuestion,
} from "../common/commonComponents";
import { CapitalIncreaseThroughBonusIssueForm } from "./capitalIncreaseThroughBonusIssueDomain";
import { VBox } from "../../components-v2/Box";
import { Warning } from "../increaseOfShareCapital/Warning";
import { IncreaseNominalValue } from "../common/commonCapitalIncreaseComponents";
import {
  AllocationStatus,
  Subscribers,
} from "../../shareholderRegister/transactions/issue/issueTransactionComponents";

import { useTranslation } from "../../stores/RootStoreContext";
import { RadioFieldQuestion } from "../../common/commonComponents";
import { shareTypeLabel } from "../../common/share";

export const CapitalIncreaseThroughBonusIssueView: FC<{
  form: CapitalIncreaseThroughBonusIssueForm;
}> = observer(({ form }) => {
  const { t } = useTranslation();
  useEffect(() => {
    form.init();
  }, [form]);

  return (
    <VBox gap={"md"}>
      <VBox>
        <YesNoQuestion
          question={t(
            "decisions.capitalIncreaseThroughBonusIssue.intermediateBalanceSheet.questionText",
          )}
          field={form.resolutionIsBasedOnIntermediateBalanceSheetModel}
          onChange={(value) => {
            form.resolutionIsBasedOnIntermediateBalanceSheetModel.setValue(value);
            form.setIntermediateBalanceSheetDateRequired();
          }}
          isLocked={form.isProjectLocked}
        />
        {form.resolutionIsBasedOnIntermediateBalanceSheetModel.value && (
          <DateQuestion
            question={t(
              "decisions.capitalIncreaseThroughBonusIssue.intermediateBalanceSheetDate.questionText",
            )}
            field={form.intermediateBalanceSheetDateModel}
            isLocked={form.isProjectLocked}
          />
        )}
        <RadioFieldQuestion
          field={form.bonusIssueTypeModel}
          fieldName="bonusIssueTypeModel"
          question={{
            key: "decisions.capitalIncreaseThroughBonusIssue.sharesOrNominalValue.questionText",
          }}
          isLocked={form.isProjectLocked}
        />
      </VBox>
      {form.showIncreaseNominalValue && (
        <IncreaseNominalValue
          increaseInNominalValue={form.increaseNominalValueByBonusIssue.increaseInNominalValue}
          currentNominalValue={form.currentNominalValue}
          currentNumberOfShares={form.currentNumberOfShares}
          isProjectLocked={form.isProjectLocked}
        />
      )}
      {form.showShareIssue && (
        <>
          <Warning message={t("decisions.capitalIncreaseThroughBonusIssue.issueShares.warning")} />
          <VBox>
            {form.shareBonusIssue.shareTypeIssues.map((sharesPerShareType) => (
              <NumberQuestion
                key={sharesPerShareType.shareType.sharetypeId}
                question={t("decisions.capitalIncreaseThroughBonusIssue.issueShares.title", {
                  shareType: t(
                    shareTypeLabel(
                      form.findShareTypeCode(sharesPerShareType.shareType.sharetypeId),
                    ),
                  ),
                })}
                field={sharesPerShareType.numberOfShares}
                isLocked={form.isProjectLocked}
              />
            ))}
          </VBox>
          <AllocationStatus model={form.shareBonusIssue} />
          <Subscribers model={form.shareBonusIssue} />
        </>
      )}
      <ArticleSelectorQuestion
        question={t("decisions.capitalIncreaseThroughBonusIssue.which-paragraph")}
        model={form.articleOfAssociationNumber}
        isLocked={form.isProjectLocked}
      />
    </VBox>
  );
});
